import { AppRegistry } from 'react-native';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import App from './App'; // Your main app component
import appJson from './app.json';

// Access the 'name' property from the imported JSON object
const { name: appName } = appJson;

// Inject style tag for react-toastify z-index on web
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = `
    .Toastify__toast-container {
      z-index: 999999 !important;
    }
  `;
  document.head.appendChild(style);
}

// Register the app component to be rendered in the "app-root" div
AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('app-root'), // Mount to "app-root" div
});